module.exports = __webpack_public_path__ + "static/media/settingclose.1f2e76f6.svg";